//const Backofficebff         : string = "/api";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OrderCommand: any = {
    PostGetOrder: Backofficebff + '/v1/order/getorder',
    PostOrdersNotFinance: Backofficebff + '/v1/orderapi/order-not-finance',
    UpdateOrderActionRules: Backofficebff + '/v1/orderapi/updateorderactionrules',
    GetOrderDetail: Backofficebff + '/v1/order/get-order-detail',
    GetSaleOrderShippingBillingAddress: Backofficebff + '/v1/order/get-sale-order-shipping-billing-address',
    GetOrderInformation: Backofficebff + '/v1/Order/get-order-information',
    UpdateSaleOrderAddress: Backofficebff + '/v1/Order/update-sale-order-address',
    UpdateShippingListCancelReason: Backofficebff + '/v1/orderapi/updateshippinglistcancelreason',
    InsertShippingListCancelReasons: Backofficebff + '/v1/orderapi/insertshippinglistcancelreason',
    GetCrossShipmentList: Backofficebff + '/v1/shipping/get-cross-shipment-shipping-list',
    GetReturnDetailByOrderId: Backofficebff + '/v1/Order/get-return-detail-by-order-id',
    GetOrderAllRefundDetails: Backofficebff + '/v1/Order/get-order-all-refund-details',
    UpdateShippingStatus: Backofficebff + '/v1/Order/update-shipping-status',
    CancelOrderStatus: Backofficebff + '/v1/Order/cancel-order-status',
    SaveShippingListStatusByRole: Backofficebff + '/v1/Order/save-shipping-list-status-by-role',
    StoreDeliveryOrders: Backofficebff + '/v1/orderapi/store-order-pending-shipping-list',
    EstimatedShippedDateByRule: Backofficebff + '/v1/orderapi/estimated-shipped-date-by-rule',
    UpdateEstimatedShippedDateForLCWByRule: Backofficebff + '/v1/orderapi/update-estimated-shipped-dateforlcw-by-rule',
    UpdateEstimatedShippedDateForMPByRule: Backofficebff + '/v1/orderapi/update-estimated-shipped-dateformp-by-rule',
    UpdateEstimatedDeliveryDateEnabledForMP: Backofficebff + '/v1/orderapi/update-delivery-estimated-dateformp-by-rule',
    ReshipShipment: Backofficebff + '/v1/order/reship-shipment',
    BulkUpdateShipmentStateExcel: Backofficebff + '/v1/order/bulk-update-shipment-state-excel',
};
